import { useMemo, useContext } from "react";
import { instanceOf } from "prop-types";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "@reach/router";

const CustomerInline = ({ customer }) => {
  const { user } = useContext(AuthContext);
  

  const sendWhatsApp = (telefono) => {
    telefono = String(telefono).replace("+52", "");
    window.open(`https://wa.me/521${telefono}`, "_blank");
  };

  const customerName = useMemo(() => {
    let name = customer.name;
    if (customer.last_name !== null) {
      name += " " + customer.last_name;
    }
    if (!name) name = "Sin Nombre";
    return name;
  }, [customer]);

  

  if (["super_admin", "admin", "manager"].includes(user.role)) {
    const customerPhone = customer.phone || null;

    return (
      <>
        <p className="small mb-0">
          <Link to={`/myadmin/customer/${customer.customer_id}`}>{customerName}</Link>
        </p>
        <p className="mb-0 small text-muted">
          <i className="fa fa-envelope me-2"></i> {customer.email}
        </p>
        {customerPhone ? (
          <button
            className="me-2 mb-0 small text-success btn btn-sm btn-link px-0 py-0"
            onClick={() => sendWhatsApp(customerPhone)}
          >
            <i className="fab fa-whatsapp me-2"></i>
            <span className="small">{customerPhone}</span>
          </button>
        ) : (
          <p className="me-2 mb-0 small text-muted">N / D</p>
        )}
      </>
    );
  }
  return <p className="mb-2">{customerName}</p>;
};

CustomerInline.propTypes = {
  customer: instanceOf(Object),
};

export default CustomerInline;
